import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { NavigateFunction } from 'react-router-dom';

import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { DATABASE, IDatabasePagingRes } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch } from '@/shared';
const { get, post, put } = erpApi();

//* tanSctack query

export const useFetchDatabases = ({
  page = 1,
  page_size = 10,
  nombre = '',
}: GetDatabaseParams) => {
  return useQuery({
    queryKey: ['databases', page, nombre, page_size],
    queryFn: async () => {
      return getDatabases({ page, nombre, page_size });
    },
  });
};

export const useGetDatabase = (id: string) => {
    return useQuery({
        queryKey: ['databases', id],
        queryFn: async () => {
        return getDatabase(id);
        },
    });
    };
    export const useCreateDatabase=(navigate: NavigateFunction, returnUrl: string) => {
        const queryClient = useQueryClient();
        return useMutation({
            mutationFn: createDatabase,
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['databases'] });
            },
            onSettled: () => {
                navigate(returnUrl);
            },
        });
    };
    export const useUpdateDatabase = (navigate: NavigateFunction, returnUrl: string) => {
        const queryClient = useQueryClient();
        return useMutation({
            mutationFn: updateDatabase,
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['databases'] });
            },
            onSettled: () => {
                navigate(returnUrl);
            },
        });
    };
    ///* axios
    export type GetDatabaseParams={
        page?: number;
        page_size?: number;
        nombre?: string;
        host?: number;
        puerto?: number;
    };
    export type CreateDatabaseParams=Omit<DATABASE, 'id_base_datos'>;
    export type UpdateDatabaseParams={
        id: number;
        data: Omit<DATABASE, 'id_base_datos'>;
    };
    //* fetch
    export const getDatabases = async (params?: GetDatabaseParams) => {
      const queryParams = getUrlParamsFetch({ ...params });
      
        return get<IDatabasePagingRes>(
          `${urlBackend}api/v1/base-datos/?${queryParams}`,
          true
        );
      };
      export const getDatabase = async (id: string) => {
        const setAlert = useUiStore.getState().setAlert;
        const res = await get<DATABASE>(`${urlBackend}api/v1/base-datos/${id}/`, true);
      
        res.status === 'error' && setAlert(true, res.message, res.status);
        return res;
      };
      export const createDatabase = async (data: CreateDatabaseParams) => {
        const setAlert = useUiStore.getState().setAlert;
        const res = await post<DATABASE>(`${urlBackend}api/v1/base-datos/`, data, true);
      
        setAlert(true, res.message, res.status);
        return res;
      };
      
      export const updateDatabase = async ({ id, data }: UpdateDatabaseParams) => {
        const setAlert = useUiStore.getState().setAlert;
        const res = await put<DATABASE>(`${urlBackend}api/v1/base-datos/${id}/`, data, true);
      
        setAlert(true, res.message, res.status);
        return res;
      };
      